export default "__VITE_ASSET__B2H8Q0rr__"